import type { SwingTimingData } from 'leaderboard/scripts/swing-path/types/globals.ts'
import { secondaryGroupHeaders } from '../../leaderboard/utils/leaderboard-filter-helpers'
import type { SecondaryGroupHeaderDisplayFn } from '../../leaderboard/utils/leaderboard-filter-helpers'

export type GroupByLogic = {
    hasGroupBys: boolean
    extraGroupBys: (keyof SwingTimingData)[]
    groupByTitles: string[]
    groupByDisplayFns: SecondaryGroupHeaderDisplayFn[]
}

export default function doGroupByLogic(groupBys: string[]): GroupByLogic {
    const extraGroupBys = groupBys.filter(
        (d) =>
            // d !== 'api_pitch_type_group03' &&
            // d !== 'pitch_hand' &&
            d !== 'api_game_date_month_mm'
    ) as unknown as (keyof SwingTimingData)[]

    const groupByTitles = extraGroupBys.map((key) => {
        if (['year', 'game_type', 'is_starter_pitcher'].includes(key)) {
            return ''
        }

        const NBSP = '\u00A0'
        if (key === 'timing_x_tiedupflail') {
            return `Timing:${NBSP}`
        }
        if (key === 'timing_y_earlylate') {
            return `Timing:${NBSP}`
        }
        if (key === 'timing_z_overunder') {
            return `Timing:${NBSP}`
        }

        if (secondaryGroupHeaders[key]?.name) {
            const label = secondaryGroupHeaders[key].name
                .replaceAll('<br/>', NBSP)
                .replaceAll('<br />', NBSP)
                .replaceAll('<br>', NBSP)
            return `${label}:${NBSP}`
        }

        return `${key}: `
    })
    const groupByDisplayFns = extraGroupBys.map((key) => {
        if (secondaryGroupHeaders[key]?.displayFn) {
            return secondaryGroupHeaders[key].displayFn
        }

        return (d: unknown) => String(d)
    })

    const hasGroupBys = Boolean(extraGroupBys.length)

    return {
        groupByTitles,
        groupByDisplayFns,
        extraGroupBys,
        hasGroupBys,
    }
}
